import { apiClient } from "helpers/api_helper";

export const getAllEnquiryData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/Enquiry/GetAllEnquiry`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};
